export const WatItalyRoutes = [
  {
    path: '/italia',
    name: 'italia',
    component: () =>
      import(
        /* webpackChunkName: "lp-watitaly" */ /* webpackPreload: true */ '../views/Landingpages/WatItaly/Italia.vue'
      ),
    meta: {
      breadcrumb: 'Italia',
    },
  },
]
